export interface RolesOption {
  value: string;
  label: string;
}

export const RolesOptions: RolesOption[] = [
  {
    value: '',
    label: 'Selecionar',
  },
  {
    value: '74',
    label: 'Proprietário(a) / Sócio(a)',
  },
  {
    value: '25',
    label: 'Presidente / CEO',
  },
  {
    value: '36',
    label: 'Administrador(a)',
  },
  {
    value: '3',
    label: 'Diretor(a)',
  },
  {
    value: '44',
    label: 'Engenheiro(a)',
  },
  {
    value: '4',
    label: 'Gerente',
  },
  {
    value: '81',
    label: 'Analista de licitação',
  },
  {
    value: '65',
    label: 'Assistente administrativo',
  },
  {
    value: '38',
    label: 'Advogado',
  },
  {
    value: '43',
    label: 'Contador',
  },
  {
    value: '64',
    label: 'Consultor(a)',
  },
  {
    value: '66',
    label: 'Representante',
  },
  {
    value: '172',
    label: 'Servidor público',
  },
];
